var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"items":_vm.PopisUsluga,"item-text":"ImeObrazovanja","return-object":"","item-value":"UpisPoId","label":_vm.$t('program_deadline.available_services')},on:{"change":function($event){return _vm.odabir(_vm.odabranaUsluga)}},model:{value:(_vm.odabranaUsluga),callback:function ($$v) {_vm.odabranaUsluga=$$v},expression:"odabranaUsluga"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-967a571e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./VueSrc/Education/program_deadline_components/SelectEducation.vue
// module id = 899
// module chunks = 0